import type { TOC } from '@ember/component/template-only';
import ParityOtaWithIcon from 'lumen/components/parity/ota-with-icon';

interface GeneralTablesCellsCellOtaSignature {
  Args: {
    value: unknown;
  };
}

const GeneralTablesCellsCellOta = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <ParityOtaWithIcon @otaId={{@value}} @size="small" />
</template> satisfies TOC<GeneralTablesCellsCellOtaSignature>;

export default GeneralTablesCellsCellOta;
